import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { TranslatePipe } from '../pipes/translate.pipe';
import { TranslationService } from '../services/translation.service';

@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <div class="callback-container">
      <div class="spinner"></div>
      <p>{{ 'logging_in' | translate:'Přihlašování' }}</p>
    </div>
  `,
  styles: [`
    /* The routed component is a flex item of .content-container (a row flex
       container), so without an explicit size it shrinks to its content width
       and the login screen renders as a strip on the left. */
    :host {
      display: block;
      width: 100%;
      height: 100%;
    }

    .callback-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      background: #1a1a2e;
      color: white;
    }

    .spinner {
      width: 50px;
      height: 50px;
      border: 4px solid rgba(255, 255, 255, 0.3);
      border-top-color: #4ade80;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-bottom: 20px;
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    p {
      font-size: 18px;
      margin: 0;
    }
  `],
})
export class CallbackComponent implements OnInit {
  private oidcSecurityService = inject(OidcSecurityService);
  private router = inject(Router);
  private translationService = inject(TranslationService);

  ngOnInit(): void {
    // Process the OIDC callback (exchange code for tokens)
    this.oidcSecurityService.checkAuth().subscribe({
      next: async (loginResponse) => {
        console.log('Auth callback processed:', loginResponse);

        if (loginResponse.isAuthenticated) {
          // Load translations now that we're authenticated
          const lang = this.translationService.getStoredLanguage();
          await this.translationService.loadTranslations(lang);

          // Get the stored redirect URL or default to home
          const redirectUrl = sessionStorage.getItem('redirectUrl') || '/';
          sessionStorage.removeItem('redirectUrl');

          // Navigate to the intended page
          this.router.navigateByUrl(redirectUrl);
        } else {
          // Authentication failed, redirect to home (will trigger login)
          console.error('Authentication failed');
          this.router.navigate(['/']);
        }
      },
      error: (error) => {
        console.error('Auth callback error:', error);
        this.router.navigate(['/']);
      },
    });
  }
}
